import * as Rollbar from "rollbar"

const isProd = process.env.NODE_ENV === "production"

export const RollbarErrorTracking = (() => {
    let RollbarObj: Rollbar
    if (isProd) {
        RollbarObj = new Rollbar({
            accessToken: "18fd9286105d40b39a033bb9d2163ef8",
            ignoredMessages: ["No message available", "Uncaught [object Object]", "disconnected", "Twilsock", "The string did not match the expected pattern", "Unexpected end of JSON input", "Error: Error while loading channel from channelSid", "Error while loading channel from channelSid"],
            captureUncaught: true,
            captureUnhandledRejections: true,
            environment: isProd ? "prod" : "stage"
        })
    }

    const logErroInfo = (info: any) => {
        if (isProd) RollbarObj.info(info);
    }

    const logErrorInRollbar = (...args: any[]) => {
        if (isProd) RollbarObj.error(...args)
    }

    return {
        logErroInfo,
        logErrorInRollbar
    }

})();

export default RollbarErrorTracking;